import { User } from 'src/@types/common.types';

export const useAnalytics = () => {
    const logAnalyticsEvent = (_eventName: string, _params?: object) => {};

    const logPageChange = (_sourcePage: string, _targetPage: string) => {};

    const registerUser = (_user: User) => {};

    const unregisterUser = () => {};

    return {
        logAnalyticsEvent,
        logPageChange,
        registerUser,
        unregisterUser,
    };
};

export default useAnalytics;
